export const gitCommit = 'f3a0481b'
